import { useState, useEffect } from 'react';
import '../App.css';

function ProgressBar({...properties}){
    const [progressClass, setProgressClass] = useState("progressBar");

    useEffect(() => {
            var progressWidth = (properties.currentTime / properties.maxTime) * 100;
            if (progressWidth <= 20){
                setProgressClass("progressBar progressBarApproachingLimit");
            }
            else {
                setProgressClass("progressBar");
            }

    }, [properties.currentTime]);

    return (
        <div id="progress" className="progressParent">
            <div id="progressBar" className={progressClass} style={{width: (properties.currentTime / properties.maxTime) * 100 + "%"}}></div>
        </div>
        );
}

export default ProgressBar;